import { Button } from 'primereact/button';
import React from 'react';

import ttecLogoUrl from '../../assets/TTECLogo.png';
import empowerLogoUrl from '../../assets/empowerLogo.png';
import leftGraphicUrl from '../../assets/leftGraphic.png';

type Props = {
    sendAuthorizationRequest: any;
};

export const Login = ({ sendAuthorizationRequest }: Props) => {
    const handleSubmit = (event: any) => {
        event.preventDefault();
        sendAuthorizationRequest();
    };
    return (
        <>
            <div className="row mt-4 loginPage">
                <div className="col-md-6">
                    <img className="justify-content-left img-fluid" src={leftGraphicUrl} alt="TTEC" />
                </div>
                <div className="col-md-6 mt-5">
                    <div className="row">
                        <div className="col-md-6">
                            <img
                                className="justify-content-left"
                                src={ttecLogoUrl}
                                alt="TTEC"
                                style={{ maxWidth: '160px' }}
                            />
                        </div>
                        <div className="col-md-6 text-end pe-5">
                            <img
                                className="justify-content-left pt-4 mt-1"
                                src={empowerLogoUrl}
                                alt="Empower"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div
                                className="card text-dark mb-3 mt-4 border-0"
                                style={{ backgroundColor: '#F3F2F2', borderRadius: '27px' }}
                            >
                                <div className="card-body text-center m-4">
                                    <h3 className="card-title text-muted p-3">Welcome back </h3>
                                    <Button
                                        onClick={handleSubmit}
                                        label="Sign in using SSO"
                                        className="p-button-rounded pe-5 ps-5"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span />
        </>
    );
};
